import { gql } from "@apollo/client";

export const FETCH_REWARD_WHEELS = gql`
  query FetchWheels($filters: RewardWheelFilters) {
    fetchRewardWheels(filters: $filters) {
      totalCount
      wheels {
        _id
        city
        state
        startDate
        endDate
        status
        displayedSlices
        shouldDuplicate
        rewardType
        totalSpins
        totalCheckouts
        createdAt
        createdBy
      }
    }
  }
`;

export const FETCH_REWARD_WHEEL_DETAILS = gql`
  query FetchWheelDetails($wheelId: ID!) {
    fetchRewardWheelDetails(wheelId: $wheelId) {
      _id
      city
      state
      startDate
      endDate
      timezone
      displayedSlices
      shouldDuplicate
      status
      rewardType
      minimumPurchase
      winProbability
      spinFrequency
      totalSpins
      totalCheckouts
      createdAt
      createdBy
      slices {
        _id
        sliceIndex
        businessId
        productId
        productName
        price
        variantId
        variantName
        rewardType
        discount
        enabled
        totalLanded
        totalCheckouts
      }
    }
  }
`;

export const CREATE_REWARD_WHEEL = gql`
  mutation CreateRewardWheel($input: CreateRewardWheelInput!) {
    createRewardWheel(input: $input) {
      success
      message
      wheel {
        _id
        city
        startDate
        endDate
        displayedSlices
        shouldDuplicate
        status
        slices {
          _id
          sliceIndex
          businessId
          productName
          rewardType
          discount
        }
      }
    }
  }
`;

export const FETCH_PRODUCTS_FOR_SLICE = gql`
  query FetchProductsForSlice(
    $businessId: ID
    $searchKeyword: String
    $pageNumber: Int
    $pageSize: Int
  ) {
    fetchProductsForSlice(
      businessId: $businessId
      searchKeyword: $searchKeyword
      pageNumber: $pageNumber
      pageSize: $pageSize
    ) {
      products {
        _id
        title
        price
        finalTotal
        discount
        quantity
        medias {
          uri
          mediaType
          uri_thumbnail
        }
        variants {
          variantId
          variantType
          variantOptions
        }
        variantCombinations {
          combination
          quantity
          price
          sku
          discount
          finalTotal
        }
        variantCombinationsCount
        businessId
        companyName
      }
      totalCount
      hasNext
    }
  }
`;

export const UPDATE_REWARD_WHEEL = gql`
  mutation UpdateWheel($input: UpdateRewardWheelInput!) {
    updateRewardWheel(input: $input) {
      success
      message
      wheel {
        _id
        city
        displayedSlices
        shouldDuplicate
        status
        slices {
          _id
          sliceIndex
          businessId
          productId
          productName
          rewardType
          discount
          enabled
        }
      }
    }
  }
`;
